import React from "react";
import { Card, Icon, Checkbox, Message } from "semantic-ui-react";
import { TIPOLOGIAS } from "../catalogs/tipologias";
import { useWaterBalanceT } from "../useWaterBalanceT";

// Paso 1: elegir la tipología precarga la biblioteca de centros y el set de
// casos de campo (Guía de campo §2) en vez de mostrar todo a todos.
export function TipologiaStep({ value, onChange }) {
  const t = useWaterBalanceT();
  const seleccionar = (id) => onChange({ ...value, typology: id });

  return (
    <div className="water-balance-step">
      <h3>{t("water_balance_typology_title")}</h3>
      <p>{t("water_balance_typology_subtitle")}</p>

      <Card.Group itemsPerRow={3} stackable>
        {Object.values(TIPOLOGIAS).map((tip) => (
          <Card key={tip.id} onClick={() => seleccionar(tip.id)} color={value.typology === tip.id ? "blue" : undefined}>
            <Card.Content>
              {value.typology === tip.id && <Icon name="check circle" color="blue" style={{ float: "right" }} />}
              <Card.Header>{tip.nombre}</Card.Header>
              <Card.Description>{tip.descripcion}</Card.Description>
            </Card.Content>
            <Card.Content extra>
              {tip.benchmark.disponible ? (
                <span><Icon name="chart bar" /> {t("water_balance_benchmark_available")}</span>
              ) : (
                <span><Icon name="info circle" /> {t("water_balance_benchmark_unavailable")}</span>
              )}
            </Card.Content>
          </Card>
        ))}
      </Card.Group>

      {value.typology === "C_PRODUCTO_TERMINADO" && (
        <Message>
          <Checkbox
            toggle
            label={t("water_balance_has_laundry_toggle")}
            checked={!!value.hasLaundry}
            onChange={(_, data) => onChange({ ...value, hasLaundry: data.checked })}
          />
          <p style={{ marginTop: 8 }}>{t("water_balance_laundry_hint")}</p>
        </Message>
      )}
    </div>
  );
}

export default TipologiaStep;
